import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DepositPromotionMutationKeys } from '../../../keys'
import {
	CreateDepositPromotionRequest,
	CreateDepositPromotionResponse,
} from '../../../type'
import { createDepositPromotion } from '../../services'

interface CreateDepositPromotionParams {
	payload: CreateDepositPromotionRequest
}

export default function useMutationCreateDepositPromotion(
	props?: UseBaseMutationOptions<
		CreateDepositPromotionResponse,
		CreateDepositPromotionParams
	>,
) {
	return useMutation({
		mutationKey: [DepositPromotionMutationKeys.CreateDepositPromotion],
		mutationFn: (params) => createDepositPromotion(params.payload),
		...props,
	})
}
